import { render, staticRenderFns } from "./ClientsVisitorsPage.vue?vue&type=template&id=1acaeee2"
import script from "./ClientsVisitorsPage.vue?vue&type=script&lang=js"
export * from "./ClientsVisitorsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports